export default "__VITE_ASSET__D6up6kqy__"